module.exports = __webpack_public_path__ + "static/tmLogo.910c489a.png";